import { ofType, ActionsObservable } from 'redux-observable';
import { map, mergeMap, delay, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';

import {
    TransformSetCaller,
    TransformSetCallerDetailsResponse
} from './transformSetCaller';
import {
    Source,
    SourceType,
    AddNewType
} from 'one-model-local';
import {
    AddNewProps
} from 'one-card-source';
import {
    addAction as addNewForm,
    setNotification as addNotification,
    resetNotification
} from 'one-state-addnew';

import {
    selectAction as selectSourceType,
} from 'one-state-source-type';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {
    addAction as addErrorAction
} from 'one-state-error/src/actions';
import { format } from 'one-util-date';
import { Disposition } from 'one-model-local';

export const enum Types {
    ADDNEW = 'one-state-addnew/call',
    SETADDNEW = 'one-state-addnew/add',
    SETADDNEWTOCALLER = 'one-state-source/set',
    SETNOTIFICATION = 'one-state-addnew/notification',
    SETSELECTEDCALLERDETAILS = 'one-state-source/select',
    ERRORADDINGADDNEW = 'one-state-addnew/error',
    STORE_DISPOSITION_CODE = "store-disposition-code",
}

const pushtoAddNewDataToCaller = (payload: any) => addNewForm(payload);
const errorAddingAddNew = (payload: any) => ({ type: Types.ERRORADDINGADDNEW, payload });
const mergePatientDataWithCaller = (payload: any) => ({ type: Types.SETADDNEWTOCALLER, payload });
const pushNotification = (payload: any) => addNotification(payload);
const reinitNotification = (payload: any) => resetNotification(payload);
const pushSelectedSouceTypeToCaller = (payload: any) => selectSourceType(payload);
const patientSelectedDataToCaller = (payload: any) => ({ type: Types.SETSELECTEDCALLERDETAILS, payload });
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

/**
 * This function will push the caller detials to db
 * based on the ani
 * @param context constains settings json etc ..
 */

export const setCallerDetailsFromAddNew = (context: any) => (
    (action$: ActionsObservable<any>, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server,
            log,
            agentId,
            teamName,
            alertnotification,
            settings:
            {
                compatible,
                epicendpoints: { setcallerdetails, apitoken }
            }
        } = context;
        const { contact_center_type } = compatible;
        return action$.pipe(
            ofType(Types.ADDNEW),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient request
                 */
                const dataresponse: any = action.payload;
                log.debug("one-epics", "setCaller request", dataresponse);
                const setCallerDetails = (payload: any) => {
                    let headers = new Headers();
                    headers.set('Authorization', 'Basic ' + apitoken?.token);
                    let data = action.payload;
                    const response = server.post({
                        path: setcallerdetails,
                        headers: headers,
                        data: data
                    }).then((responsefound: any) => responsefound)
                        .catch((responseresult: any) => {
                            log.error("one-epic", "setCallerDetailsFromAddNew Error", responseresult);
                            // SEND to ALERT notificaiton/NOC servers for critical error on no active server
                            if (responseresult?.status === 0) {
                                if (alertnotification?.isEnabled()) {
                                    var timestamp = new Date().toJSON();
                                    alertnotification.notify({
                                        "error_code": "930-31",
                                        "error_type": "SERVER_ERROR",
                                        "error_description": "Unable to reach active servers",
                                        "error_supertype": "SERVER_FAILS",
                                        "error_detail": "Unable to reach any of server for retring data ",
                                        "alert": "Yes",
                                        "timestamp": timestamp,
                                        "params": responseresult
                                    });
                                }
                            }

                            // user exception for adding new record send to NOC
                            if (alertnotification?.isEnabled()) {
                                var timestamp1 = new Date().toJSON();
                                alertnotification.notify({
                                    "error_code": "630-32",
                                    "error_type": "USER_NEW_RECORD_ERROR",
                                    "error_description": "Unable to reach active servers",
                                    "error_supertype": "USER_CREATION_ERROR",
                                    "error_detail": "Error while adding new Patient or Provider",
                                    "alert": "No",
                                    "timestamp": timestamp1,
                                    "params": responseresult
                                });
                            }
                            let addnewerror: ErrorObject = {
                                source: "AddNew",
                                type: "error",
                                status: responseresult?.status,
                                erroritems: responseresult?.errors,
                                error_date: errorDate,
                                error_time: errorTime
                            };
                            return addnewerror;
                        })
                    log.debug("one-epics", "setCaller Epic response", response);
                    return from(response);
                }
                return setCallerDetails(dataresponse).pipe(
                    map(response => TransformSetCaller(response, action.payload, context))
                ).pipe(
                    flatMap(response => {
                        const actions: any = [];
                        if (response.error === undefined && response?.addnewdata?.id?.length > 0) {
                            //If api is successful
                            actions.push(pushtoAddNewDataToCaller(response.addnewdata));
                            //Dispostion Framework
                            let disp: Disposition = { value: "177" }
                            if (contact_center_type && contact_center_type === 'five9') {
                                let agentIdValue = sessionStorage.getItem("agentName");
                                let skillName = sessionStorage.getItem("skillName");
                                disp.meta00 = agentIdValue;
                                disp.meta01 = skillName;
                                disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                            } else {
                                disp.meta00 = agentId;
                                disp.meta01 = teamName;
                                disp.dial_list_uid = state$.value.choosecaller?.callId;
                            }
                            disp.meta02 = dataresponse.phone;
                            disp.meta03 = dataresponse.name;
                            disp.meta04 = dataresponse.typeName;
                            disp.meta05 = dataresponse.subTypeName;
                            disp.meta06 = 'client';
                            actions.push(pushToDisposition(disp));
                        } else {
                            //If api has backend issues
                            actions.push(errorAddingAddNew(response.addnewdata));
                            //Dispostion Framework
                            let disp: Disposition = { value: "992" }
                            if (contact_center_type && contact_center_type === 'five9') {
                                let agentIdValue = sessionStorage.getItem("agentName");
                                let skillName = sessionStorage.getItem("skillName");
                                disp.meta00 = agentIdValue;
                                disp.meta01 = skillName;
                                disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                            } else {
                                disp.meta00 = agentId;
                                disp.meta01 = teamName;
                                disp.dial_list_uid = state$.value.choosecaller?.callId;
                            }
                            disp.meta02 = dataresponse.phone;
                            disp.meta03 = dataresponse.name;
                            disp.meta04 = dataresponse.typeName;
                            disp.meta05 = dataresponse.subTypeName;
                            disp.meta06 = 'client';
                            actions.push(pushToDisposition(disp));
                        }
                        // check for error messages.
                        if (response.error) {
                            actions.push(addErrorAction(response.error));
                        }
                        return actions;
                    })
                )
            })
        )
    }

);

/**
 * This Function is used to add notification for add new Source
 * @param context contains settings json etc ..
 */
export const checkForAddNewNotification = (context: any) => (
    (action$: any, state$: any) => {
        const {
            log
        } = context;
        return action$.pipe(
            ofType(Types.SETADDNEW, Types.ERRORADDINGADDNEW),
            mergeMap((action: any) => {
                /**
                 * @param dataresposne contains the patientlookup response
                 */
                let dataresponse = action.payload;
                log.debug("one-epics", "AddNew Notification request", dataresponse);
                if (dataresponse) {
                    const getRequest = (datares: any) => {
                        let notification: AddNewType = {};
                        if (datares && datares?.id?.length > 0) {
                            notification.value = false;
                            notification.notification = true;
                            notification.addnewspin = false;
                            notification.notificationmsg = "Record Inserted Successfully."
                        } else {
                            notification.value = true;
                            notification.notification = true;
                            notification.addnewspin = false;
                            notification.notificationmsg = "Caller record was not successfully created."
                        }
                        log.debug("one-epics", "AddNew Notification response", notification);
                        return from([notification]);
                    }
                    return getRequest(dataresponse).
                        pipe(
                            map(response => pushNotification(response))
                        )
                }
            })

        )
    }
);

/**
 * This Function is used to add new Source to the existing
 * Source resides in the state and merge it
 * @param context contains settings json etc ..
 */
export const pushAddNewDataToCaller = (context: any) => (
    (action$: any, state$: any) => {
        const {
            log
        } = context;
        return action$.pipe(
            ofType(Types.SETADDNEW),
            mergeMap((action: any) => {
                /**
                 * @param dataresposne contains the patientlookup response
                 */
                let dataresponse = action.payload;
                if (dataresponse) {
                    log.debug("one-epics", "MergeAddNewToCaller request", dataresponse);
                    const getRequest = (datares: any) => {
                        let result: Source[] = TransformSetCallerDetailsResponse(datares, context);
                        log.debug("one-epics", "MergeAddNewToCaller response", result);
                        return from([result]);
                    }
                    return getRequest(dataresponse).
                        pipe(
                            map(response => mergePatientDataWithCaller(response))
                        )
                }
            })

        )
    }
);

/**
 * This Function is used to change the Source Type
 * when ever a new Source is added
 * @param context contains settings json etc ..
 */
export const pushAddNewSelectedSouceTypeToCaller = (context: any) => (
    (action$: any) => {
        const {
            log,
            settings:
            {
                soucetypelookup
            }
        } = context;
        return action$.pipe(
            ofType(Types.SETADDNEW),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contain AddNew object
                 */
                let dataresponse = action.payload;
                if (dataresponse) {
                    log.debug("one-epics", "AddNew SelectedSourceType request", dataresponse);
                    const getRequest = (datares: any) => {
                        const typeName = datares?.typeName;
                        const sourcetypeselected: SourceType = soucetypelookup?.find(
                            (item: any) => item.label === typeName
                        );
                        //state.selected = patientselected;
                        log.debug("one-epics", "AddNew SelectedSourceType response", sourcetypeselected);
                        return from([sourcetypeselected]);
                    }

                    return getRequest(dataresponse).pipe(
                        map(response => pushSelectedSouceTypeToCaller(response))
                    )
                }
            })

        )
    }
);

/**
 * This Function is used to add selected patient/provider
 *  to the source card when ever we add a record using new Source popup form
 * @param context contains settings json etc ..
 */
export const pushAddNewSelectedPatientDataToCaller = (context: any) => (
    (action$: any, state$: any) => {
        const {
            log
        } = context;
        return action$.pipe(
            ofType(Types.SETADDNEW),
            //ADPAC-331, watch in production for the delay loading.
            delay(1000),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contain AddNew object
                 */
                var dataresponse = action.payload;
                if (dataresponse) {
                    log.debug("one-epics", "AddNew SelectedPatient request", dataresponse);
                    const getRequest = (datares: any) => {
                        let addNewObject: AddNewProps = state$.value.addnew;
                        let value: string;
                        value = addNewObject?.addnew?.id;
                        log.debug("one-epics", "AddNew SelectedPatient response", value);
                        return from([value]);
                    }
                    return getRequest(dataresponse).pipe(
                        map(response => patientSelectedDataToCaller(response))
                    )
                }
            })

        )
    }
);